import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import gql from "graphql-tag";
import { isObjectLike } from "lodash";

@Injectable()
export class LocationsService {
  constructor(private apollo: Apollo) {}

  list(obj?) {
    let variables = {}; // Initialize the variables object

    if (obj) {
      // Populate variables if obj is provided
      variables = {
        first: obj.paginationData.pageSize || 10,
        after: obj.paginationData.after
          ? obj.paginationData.after.endCursor
          : null,
        searchParam: obj.searchParam || null,
      };
    }

    // Return the Apollo watchQuery
    return this.apollo.watchQuery({
      query: gql`
        query GetLocations($first: Int, $after: String, $searchParam: String) {
          locations(first: $first, after: $after, searchParam: $searchParam) {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              node {
                id
                name
                dzongkha
                slug
                description
                geoCoordinate
                isDistrict
                region
                children {
                  id
                }
              }
            }
            totalCount
          }
        }
      `,
      variables, // Pass variables object
      errorPolicy: "all", // Optional error handling
    }).valueChanges;
  }

  read(id: string) {
    return this.apollo.watchQuery({
      query: gql`
        {
          location(id: "${id}") {
            id
            name
            dzongkha
            slug
            description
            geoCoordinate
            isDistrict
            published
            region
            seoTitle
            seoDescription
            parent {
              id
              name
            }
            children {
              id
              name
              children{
                id
                name
              }

            }
            photos {
              id
              path
              url(w:150, h:150)
              originalUrl
              premium
              private
              credit
              caption
              colors
              mimetype
              editor
              licensedBy
              licensed
              sublicenseable
              owned
            }
            video {
              id
              path
              url
              credit
              premium
              private
              caption
              colors
              mimetype
              editor
              licensedBy
              licensed
              sublicenseable
              owned
            }
            featuredPhoto {
              id
              url(w:150, h:150)
              path
              mimetype
              credit
              caption
              editor
            }
            meetTheLocals {
                id
                path
                url(w:150, h:150)
            }
            gallery {
              id
              path
              url(w:150, h:150)
            }
          }
        }
      `,
    }).valueChanges;
  }

  create(obj) {
    obj.slug = " ";
    return this.apollo.mutate({
      mutation: gql`
        mutation createLocation(
          $name: String!
          $slug: String!
          $dzongkha: String
        ) {
          createLocation(
            location: { name: $name, slug: $slug, dzongkha: $dzongkha }
          ) {
            id
            name
            dzongkha
            slug
          }
        }
      `,
      variables: {
        name: obj.name,
        slug: obj.slug,
        dzongkha: obj.dzongkha,
      },
    });
  }

  update(obj) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updateLocation(
          $id: String!
          $name: String!
          $slug: String!
          $dzongkha: String
          $description: String
          $parentId: String
          $published: Boolean
          $region: String
          $seoTitle: String
          $seoDescription: String
        ) {
          updateLocation(
            location: {
              id: $id
              name: $name
              slug: $slug
              dzongkha: $dzongkha
              description: $description
              parentId: $parentId
              published: $published
              region: $region
              seoTitle: $seoTitle
              seoDescription: $seoDescription
            }
          ) {
            success
          }
        }
      `,
      variables: {
        id: obj.id,
        name: obj.name,
        slug: obj.slug,
        dzongkha: obj.dzongkha,
        description: obj.description,
        parentId: obj.parentId,
        published: obj.published,
        region: obj.region,
        seoTitle: obj.seoTitle,
        seoDescription: obj.seoDescription,
      },
    });
  }

  delete(obj) {
    return this.apollo.mutate({
      mutation: gql`
        mutation removeLocation {
          removeLocation(location: {id: "${obj.id}"}) {
            success
          }
        }
      `,
    });
  }

  getAllLocation() {
    return this.apollo.watchQuery({
      query: gql`
        {
          allLocations {
            id
            name
            isDistrict
            published
          }
        }
      `,
    }).valueChanges;
  }
  getLocationGallery(id: string) {
    return this.apollo.watchQuery({
      query: gql`
          {
            location(id: "${id}") {

              id
              description

              gallery {
                id
                path
                url(w:150, h:150)
              }
              featuredPhoto {
                id
                path
                url(w:150, h:150)
              }
              meetTheLocals {
                id
                path
                url(w:150, h:150)
              }
            }
          }
        `,
    }).valueChanges;
  }

  getLocationRegions() {
    return this.apollo.watchQuery({
      query: gql`
        {
          locationRegions {
            key
            name
          }
        }
      `,
    }).valueChanges;
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/locations.service.ts